"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitForIssuesAnalyticsBaseProps = exports.setIssueAnalyticsBaseProps = exports.getQueuedEvents = exports.getIssuesPropsToWaitFor = exports.getIssuesBaseProps = exports.getIssuesAnalyticsBaseProps = exports.enqueueIssuesAnalyticsEvent = exports.dequeueAllIssuesAnalyticsEvents = exports.clearIssuesPropsToWaitFor = exports.clearBaseProps = exports.areAllIssuesAnalyticsBasePropsReady = void 0;
var _trackEvent = require("./trackEvent");
let issuesPropsToWaitFor = new Set();
let issuesBaseProps = {};
let queuedEvents = [];
const waitForIssuesAnalyticsBaseProps = function () {
  for (var _len = arguments.length, propsToWaitFor = new Array(_len), _key = 0; _key < _len; _key++) {
    propsToWaitFor[_key] = arguments[_key];
  }
  propsToWaitFor.forEach(prop => issuesPropsToWaitFor.add(prop));
};
exports.waitForIssuesAnalyticsBaseProps = waitForIssuesAnalyticsBaseProps;
const getIssuesPropsToWaitFor = () => {
  return issuesPropsToWaitFor;
};
exports.getIssuesPropsToWaitFor = getIssuesPropsToWaitFor;
const getIssuesBaseProps = () => {
  return issuesBaseProps;
};
exports.getIssuesBaseProps = getIssuesBaseProps;
const getQueuedEvents = () => {
  return queuedEvents;
};
exports.getQueuedEvents = getQueuedEvents;
const setIssueAnalyticsBaseProps = propKeyValues => {
  issuesBaseProps = {
    ...issuesBaseProps,
    ...propKeyValues
  };
  if (areAllIssuesAnalyticsBasePropsReady()) {
    dequeueAllIssuesAnalyticsEvents();
  }
};
exports.setIssueAnalyticsBaseProps = setIssueAnalyticsBaseProps;
const getIssuesAnalyticsBaseProps = () => {
  return issuesBaseProps;
};
exports.getIssuesAnalyticsBaseProps = getIssuesAnalyticsBaseProps;
const areAllIssuesAnalyticsBasePropsReady = () => {
  return Array.from(getIssuesPropsToWaitFor()).every(propToWaitFor => {
    return issuesBaseProps[propToWaitFor] !== null && issuesBaseProps[propToWaitFor] !== undefined;
  });
};
exports.areAllIssuesAnalyticsBasePropsReady = areAllIssuesAnalyticsBasePropsReady;
const enqueueIssuesAnalyticsEvent = (eventName, eventProps) => {
  queuedEvents.push([eventName, eventProps]);
};
exports.enqueueIssuesAnalyticsEvent = enqueueIssuesAnalyticsEvent;
const dequeueAllIssuesAnalyticsEvents = () => {
  queuedEvents.forEach(_ref => {
    let [eventName, eventProps] = _ref;
    (0, _trackEvent.trackEvent)({
      name: eventName,
      parameters: eventProps
    });
  });
  queuedEvents = [];
};
exports.dequeueAllIssuesAnalyticsEvents = dequeueAllIssuesAnalyticsEvents;
const clearBaseProps = () => {
  issuesBaseProps = {};
};
exports.clearBaseProps = clearBaseProps;
const clearIssuesPropsToWaitFor = () => {
  issuesPropsToWaitFor = new Set();
};
exports.clearIssuesPropsToWaitFor = clearIssuesPropsToWaitFor;
//# sourceMappingURL=issuesBaseProps.js.map